import React from "react";

import { SVG } from "./styles";
import { getDefaultHeight } from "./utils";

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export const AlertIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21.5 21.5"
      height={getDefaultHeight(svgProps, 21.5)}
      {...svgProps}
    >
      <g
        fill="none"
        stroke={color ?? "currentColor"}
        strokeLinecap="round"
        strokeWidth="1.5"
      >
        <path
          d="M10.769 16.75a.333.333 0 10.333.333.333.333 0 00-.333-.333h0"
          strokeLinejoin="round"
        />
        <path strokeMiterlimit="10" d="M10.769 14.084V7.417" />
        <path
          d="M12.21 1.648a1.605 1.605 0 00-2.882 0L.908 18.8a1.352 1.352 0 001.211 1.95h17.3a1.352 1.352 0 001.211-1.95z"
          strokeLinejoin="round"
        />
      </g>
    </SVG>
  );
};
